import { Pipe, PipeTransform } from '@angular/core';
import { ChartOfAccountsNodeNature } from '../../../../data/src/lib/entities/chart-of-accounts.model';

const NATURE_TRANSLATE_KEYS: Record<ChartOfAccountsNodeNature, string> = {
  [ChartOfAccountsNodeNature.Revenue]: 'TREASURY.CHART_OF_ACCOUNTS.NATURE.REVENUE',
  [ChartOfAccountsNodeNature.Deduction]: 'TREASURY.CHART_OF_ACCOUNTS.NATURE.DEDUCTION',
  [ChartOfAccountsNodeNature.Cost]: 'TREASURY.CHART_OF_ACCOUNTS.NATURE.COST',
  [ChartOfAccountsNodeNature.OperationalExpense]: 'TREASURY.CHART_OF_ACCOUNTS.NATURE.OPERATIONAL_EXPENSE',
  [ChartOfAccountsNodeNature.FinancialIncome]: 'TREASURY.CHART_OF_ACCOUNTS.NATURE.FINANCIAL_INCOME',
  [ChartOfAccountsNodeNature.FinancialExpense]: 'TREASURY.CHART_OF_ACCOUNTS.NATURE.FINANCIAL_EXPENSE',
};

@Pipe({ name: 'chartOfAccountsNatureKey', standalone: true, pure: true })
export class ChartOfAccountsNatureKeyPipe implements PipeTransform {
  public transform(value: ChartOfAccountsNodeNature): string {
    return NATURE_TRANSLATE_KEYS[value];
  }
}
